import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    boxSizing: "border-box",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

/**
 * Salesforceの認証情報がないときに表示されるコンポーネント
 */
class SalesforceNotAuthorize extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            認証情報が見つかりません。
            <a
              href={
                process.env.REACT_APP_API_BASE_URL +
                "/oauth2/salesforce?redirect_url=" +
                process.env.REACT_APP_FRONTEND_URL +
                "/setting/integrations/salesforce"
              }
              target="_self"
              className={classes.link}
            >
              こちら
            </a>
            より設定してください。
          </Typography>
        </div>
      </div>
    );
  }
}

SalesforceNotAuthorize.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesforceNotAuthorize);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceNotAuthorize.jsx